export default "__VITE_ASSET__DX0oe2x0__"